import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import {channel} from '@/views/im-channel/data.js';

/**
 * 格式化聊天对话列表数据
 *
 * @param {Object} params
 */
export function formatTalkUser(params) {
	  let options = {
		session_id: params.sessionId,
		channel: params.channel,
		brand: params.brandId,
		skillGroup: params.skillGroup,
		sender_id: params.customerId,
		headimgurl: params.customerInfo && params.customerInfo.headimgurl ? params.customerInfo.headimgurl : 'https://assistant-cdn.porsche-scrm-engagement.com/static/images/avator.png',
		nickname: params.customerInfo && params.customerInfo.nickname ?params.customerInfo.nickname : '--',
		brandDesc: params.brandDesc,
		skillGroupDesc: params.skillGroupDesc,
		is_top: 0,//是否置顶
		unread_num: 0,//未读
		content: params.msg,//客人最新消息
		draft_text: '',//草稿
		sendtime: params.updateTime || params.sendtime,
		sender_type:params.sender_type
	  }
	 Object.assign(options, params)
	return options
}
/**
 * 打开指定对话窗口
 *
 * @param {Integer} talk_type 对话类型[1:私聊;2:群聊;]
 * @param {Integer} receiver_id 接收者ID
 */
export function toTalk(session_id) {
	Vue.prototype.$api.getImDialogueLists(session_id).then(res => {
		if(res.errcode != 0) return;
		//store.commit('imChatService/SET_INDEX_NAME',session_id);
		//store.commit('imChatService/SET_INDEX_INFOS',formatTalkUser(res.data));
		if(findTalkIndex(session_id) == -1){
			store.commit('imChatService/PUSH_TALK_ITEM', formatTalkUser(res.data))
		}
		router.push({
			path: '/im/index',
			query: {
			        v: new Date().getTime(),
			 },
		})
	})
}
/**
 * 时间格式化方法
 *
 * @param {(Object|string|number)} time
 * @param {String} cFormat
 * @returns {String | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  let date
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'

  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }

    date = new Date(time.replace(/-/g, '/'))
  }

  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }

  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }

    return value.toString().padStart(2, '0')
  })

  return time_str
}
/**
 * 人性化显示时间
 *
 * @param {Object} datetime 2011-07-08 05:25:32
 */
export function friendlyFormatTime(datetime = '') {
  if (datetime == null) {
    return ''
  }

  datetime = datetime.replace(/-/g, '/')

  let time = new Date()
  let outTime = new Date(datetime)
  if (/^[1-9]\d*$/.test(datetime)) {
    outTime = new Date(parseInt(datetime) * 1000)
  }

  if (time.getTime() < outTime.getTime()) {
    return parseTime(outTime, '{y}/{m}/{d} {h}:{i}')
  }

  if (time.getFullYear() != outTime.getFullYear()) {
    return parseTime(outTime, '{y}/{m}/{d} {h}:{i}')
  }

  if (time.getMonth() != outTime.getMonth()) {
    return parseTime(outTime, '{m}/{d} {h}:{i}')
  }

  if (time.getDate() != outTime.getDate()) {
    let day = outTime.getDate() - time.getDate()
    if (day == -1) {
      return parseTime(outTime, '昨天 {h}:{i}')
    }

    if (day == -2) {
      return parseTime(outTime, '前天 {h}:{i}')
    }

    return parseTime(outTime, '{m}-{d} {h}:{i}')
  }

  if (time.getHours() != outTime.getHours()) {
    return parseTime(outTime, '{h}:{i}')
  }

  let minutes = outTime.getMinutes() - time.getMinutes()
  if (minutes == 0) {
     return parseTime(outTime, '{h}:{i}')//return '刚刚'
  }

  minutes = Math.abs(minutes)
  return  parseTime(outTime, '{h}:{i}') //`${minutes}分钟前`
}

 /* 去重*/
export function uniqueArray(arr,key){
	let cache = [];
	if(!Array.isArray(arr)) return cache;
 	for (let item of arr) {
 		if (cache.find(v => v[key] == item[key])) {
 			continue
 		}
 		cache.push(item)
 	}
 	return cache
}
 
 /* im服务窗口功能按钮权限*/
export function getImServiceAuth(auth_id){
	if(store.state.imChatService.chatAuthSetting.length == 0) return true;
	let index = store.state.imChatService.chatAuthSetting.findIndex(el => el.id == auth_id);
	if(index == -1) return true;
	return store.state.imChatService.chatAuthSetting[index].enabled;
}

/**
 * 根据渠道判断是否展示可发送类型
 *
* @param {String} type 渠道类型
* @param {String} sendtype 发送类型
 */
 export function isCanSend(type,sendtype){
	 let type_index = channel.findIndex(el => el.key == type);
	 if(type_index != -1) {
		 if(channel[type_index].type.includes(sendtype)){
			 return true
		 }
		 return false
	 }
	 return false
 }
 
 /**
  * 通过对话索引查找对话列表下标
  *
  * @param {String} session_id
  */
export function findTalkIndex(session_id) {
return store.state.imChatService.items.findIndex(
 item => item.session_id == session_id
)
}
 
 /**
  * 通过对话索引查找对话列表
  *
  * @param {String} session_id
  */
export function findTalk(session_id) {
return store.state.imChatService.items.find(item => item.session_id == session_id)
}

 /**
  * 根据渠道展示图标
  *
  * @param {String} channel
  */
 export function getCnannelIcon(type){
 	let icon = '';
 	switch(type){
 		case 'wechat':
 			icon = 'major-weixin'
 			break;
 		case 'web':
 			icon = 'major-wangzhan'
 			break;
 		case 'weibo':
 			icon = 'major-weibo2'
 			break;
 		case 'miniProgram':
 			icon = 'major-weixinxiaochengxu'
 			break;
 		case 'tikTok':
 			icon = 'major-douyintexiao'
 			break;
 		case 'qyWechat':
 			icon = 'major-qiyeweixin'
 			break;
 		case 'Baiduminiprogram':
 			icon = 'major-baidu'
 			break;
 		case 'JDongminiprogram':
 			icon = 'major-jingdong'
 			break;
 		case 'app':
 			icon = 'major-44'
 			break;
 	}
 	return icon
 }